
/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import styled from '@emotion/styled';
import { useLocalization } from "gatsby-theme-i18n";
import { SectionRow, SectionTextColumn, SectionImageColumn } from '../../../components/CommonSection'; 
import * as breakpoint from '../../../styles/breakpoints.module.scss';
import * as config from '../../../styles/config.module.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";


const CyalumeSection = ({image}) => {
  const { t } = useLocalization();

  return(
      <SectionRow css={css`
        align-items:center;

        @media only screen and (max-width: ${breakpoint.smMax}){
          width:100%;
          padding-top:32px;
          display:flex;
          justify-content: space-between;
        }

        @media only screen and (max-width: ${breakpoint.xsMax}){
          display:block;
        }
      `}>
        <SectionTextColumn css={css`
          width: calc(50% + 32px);
          @media only screen and (max-width: ${breakpoint.smMax}){
            width: calc(50% - 16px);
            padding:0 !important;
          }

          @media only screen and (max-width: ${breakpoint.xsMax}){
            width:100%;
            padding-bottom:32px !important; 
          }
        `}>
          
          <SectionTitle>
            <SectionSubtitle>{t('ticket.cyalume.subtitle')}</SectionSubtitle>
            {t('ticket.cyalume.title')}
          </SectionTitle>
          <SectionContent>{t('ticket.cyalume.message')}</SectionContent>
          <SectionAnnotation>{t('ticket.cyalume.annotation')}</SectionAnnotation>
        </SectionTextColumn>
        <SectionImageColumn css={css`
          width: calc(50% - 16px);
          @media only screen and (max-width: ${breakpoint.smMax}){
            width: calc(50% - 16px);
          }
          @media only screen and (max-width: ${breakpoint.xsMax}){
            width:100%;
          }
        `}>
          <GatsbyImage image={getImage(image)} alt={t('ticket.cyalume.title')}/>
        </SectionImageColumn>
      </SectionRow>
  );
}

export default CyalumeSection;


const SectionTitle = styled.h2`
  font-size: ${config.fontSizeH1};
  display:block;
  margin-bottom:16px;
  color: #2C2C2E;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: ${config.fontSizeSMH1};
    line-height:129%;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: ${config.fontSizeXSH1};
    line-height:140%;
  }
`
const SectionSubtitle = styled.span`
  color: #D00F31;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.03em;
  font-weight: 900;
  margin-bottom:8px;
  display:block;

  @media only screen and (max-width: ${breakpoint.smMax}){
    font-size: 12px;
    line-height: 16px;
    margin-bottom:4px;
  }

  @media only screen and (max-width: ${breakpoint.xsMax}){
    font-size: 10px;
    line-height:140%;
    margin-bottom:0px;
  }
`
const SectionContent = styled.div`
  font-size: ${config.fontSizeSmall};
  line-height:24px;
  display:block;
  color: #444448;
`

const SectionAnnotation = styled.div`
  font-size: ${config.fontSizeSmall};
  line-height:24px;
  display:block;
  color: #C62828;
  margin-top:16px;
`
